import Query from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const setDynamicUserDataMutation = async ({attributeName, attributeData, user}) => {
  const params = user ? { 'user_uuid': user.uuid } : {};
  params['attribute_name'] = attributeName;
  params['data'] = attributeData;

  const { data } = await Query(`mutation {
    set_dynamic_user_data(${jsonToInputParams(params)}) {
      success
      errors
    }
  }`);
  return {
    success: resolve(data, 'set_dynamic_user_data/success', false),
    errors: resolve(data, 'set_dynamic_user_data/errors', [])
  };
};

export default setDynamicUserDataMutation;
